export enum Dictionaries {
  COUNTRIES = 'Countries',
  LANGUAGE = 'Language',
  CURRENCIES = 'Currencies',
}
